export enum RegistrationType {
    TicketPurchase = 0,
    TicketAllocation = 1,
    SessionDelegate = 2,
    Complimentary = 3,
    Sponsor = 4
}